import React, { useRef } from 'react';
import styles from './BoxNavigation.module.scss';
import { Link } from 'react-router-dom';
import { addCustomPathToLink, TitleOverlayWrapper } from '../../functions';

const BoxNavigation = ({ api }) => {
  const titleWrapperRef = useRef();

  return (
    <section
      id={api?.id}
      className={styles.SectionNavigation}
      data-aos="fade-up"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
    >
      <img className={styles.imageBackground} src={addCustomPathToLink(api.attributes.image.src, true)} alt={api.attributes.image.alt} />
      <TitleOverlayWrapper styles={styles} titleWrapperRef={titleWrapperRef} api={api}>
        <Link
          ref={titleWrapperRef}
          className={styles.textContent}
          data-aos="fade-right"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
          to={!!api?.attributes?.btnLink ? addCustomPathToLink(`${api.attributes.btnLink}`) : '#'}
        >
          {!!api?.attributes?.title && <h1 className={styles.title}>{api.attributes.title}</h1>}
          <p className={styles.linkNav}>{!!api?.attributes?.btnText ? api.attributes.btnText : 'Zobacz więcej'}</p>
        </Link>
      </TitleOverlayWrapper>
    </section>
  );
};
export default BoxNavigation;
